import { createFileRoute } from '@tanstack/react-router';
import LazyRoute from '@/components/LazyRoute';
import { TablePageLoader } from '@/components/ui/page-loader';

export const Route = createFileRoute('/_protected/organization/settings/secrets')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/secrets')}
      fallback={<TablePageLoader />}
    />
  ),
});
